import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';

/**
 * Add-Moderator dialog. Extracted from ChatbotDetailPage.jsx (iter132.2).
 * Parent owns the email state + submit; this component clears its input
 * via ``onOpenChange(false)`` because the parent already resets state on
 * cancel/success.
 */
export const AddModeratorDialog = ({
  open,
  onOpenChange,
  newModeratorEmail,
  setNewModeratorEmail,
  addingModerator,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white border-slate-200 max-w-md">
      <DialogHeader>
        <DialogTitle className="text-slate-900">Add Moderator</DialogTitle>
        <DialogDescription className="text-slate-600">
          Enter the email address of the person you want to add as a moderator.
          If they already have an account they&apos;ll get immediate access;
          otherwise an invitation email will be sent.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <div>
          <Label className="text-slate-600">Email Address</Label>
          <Input
            type="email"
            value={newModeratorEmail}
            onChange={(e) => setNewModeratorEmail(e.target.value)}
            placeholder="moderator@example.com"
            className="bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 mt-1"
            data-testid="moderator-email-input"
          />
        </div>
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => {
            onOpenChange(false);
            setNewModeratorEmail('');
          }}
          className="border-slate-300 text-slate-700"
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={addingModerator || !newModeratorEmail.trim()}
          className="bg-blue-600 hover:bg-blue-700"
          data-testid="submit-moderator-btn"
        >
          {addingModerator && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          Add Moderator
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default AddModeratorDialog;
